import { Buffer } from 'buffer'

export const decode = (a) => {
  return Buffer.from(a, 'base64').toString('binary')
}

export const encode = (string) => Buffer.from(string).toString('base64')

export const encodeId = (type, id) => {
  if (!type || !id) return
  return Buffer.from(`gid://shopify/${type}/${id}`).toString('base64')
}

export const extractIdFromGid = (gid) => {
  if (!gid) return null
  const gidArr = decode(gid).split('/')
  return gidArr[gidArr.length - 1]
}
